import { Group } from '@mantine/core';
import { IconChevronsRight, IconFileDescription, IconMail, IconRotateRectangle, IconSignature } from '@tabler/icons';
import { FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useNavigationItem } from '../../../Organismns/Navigation/NavigationItemHook';
import ActionIconWithText from './ActionIconWithText';

interface HandlersProps {
  openNavBar: () => void;
}

const SettingsFooter: FC<HandlersProps> = ({ openNavBar }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const showMiddleIcon = !pathname.endsWith('positions');

  return (
    <Group px="xl" pt={5} sx={{ justifyContent: 'space-between' }}>
      <ActionIconWithText useDefaultWidth label="Alle" onClick={openNavBar}>
        <IconChevronsRight />
      </ActionIconWithText>
      <ActionIconWithText
        useDefaultWidth
        label="Emails"
        active={useNavigationItem(`/settings/messages`)}
        onClick={() => navigate(`/settings/messages`)}
      >
        <IconMail />
      </ActionIconWithText>

      <ActionIconWithText
        useDefaultWidth
        label={showMiddleIcon ? 'Dokumente' : ''}
        active={useNavigationItem(`/settings/templates`)}
        onClick={() => navigate(`/settings/templates`)}
        sx={{ display: showMiddleIcon ? undefined : 'none' }}
      >
        <IconFileDescription />
      </ActionIconWithText>

      <ActionIconWithText
        useDefaultWidth
        label="Verträge"
        active={useNavigationItem(`/settings/contracts`)}
        onClick={() => navigate(`/settings/contracts`)}
      >
        <IconSignature />
      </ActionIconWithText>
      <ActionIconWithText
        useDefaultWidth
        label="Workflows"
        active={useNavigationItem(`/settings/workflow`)}
        onClick={() => navigate(`/settings/workflow`)}
      >
        <IconRotateRectangle size={16} />
      </ActionIconWithText>
    </Group>
  );
};

export default SettingsFooter;
